import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'
/* Layout */
import LayoutHide from '../views/layout/LayoutHide'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {
    path: '',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: {title: '首页', icon: 'home'}
    }]
  }
]

export const asyncRouterMap = [
  {
    path: '/serverInfoManage',
    component: LayoutHide,
    redirect: 'noredirect',
    name: 'serverInfoManage',
    meta: {title: '渠道信息管理', icon: 'server'},
    children: [
      {
        path: '/serverInfoManage/isv',
        component: Layout,
        redirect: 'noredirect',
        name: 'isv',
        meta: {title: 'isv管理', icon: 'isv'},
        children: [
          {
            path: 'merchantInfo',
            name: 'merchantInfo',
            component: () => import('@/views/serverInfoManage/isv/merchantInfo/index'),
            meta: {title: 'isv管理', icon: 'tags'}
          },
        ]
      },
      {
        path: '/serverInfoManage/partner',
        component: Layout,
        redirect: 'noredirect',
        name: 'partner',
        meta: {title: '渠道管理', icon: 'partner'},
        children: [
          {
            path: 'partnerList',
            name: 'partnerList',
            component: () => import('@/views/serverInfoManage/partner/partnerList/index'),
            meta: {title: '合作机构列表', icon: 'tags'}
          },
          {
            path: 'addPartner',
            name: 'addPartner',
            component: () => import('@/views/serverInfoManage/partner/partnerList/add'),
            meta: {title: '添加'},
            hidden: true
          },
        ]
      },
    ]
  },

  {
    path: '/systemManage',
    component: LayoutHide,
    redirect: 'noredirect',
    name: 'systemManage',
    meta: {title: '系统管理', icon: 'system-info'},
    children: [
      {
        path: '/systemManage/ums',
        component: Layout,
        redirect: 'noredirect',
        name: 'ums',
        meta: {title: '权限', icon: 'ums'},
        children: [
          {
            path: 'role',
            name: 'role',
            component: () => import('@/views/systemManage/ums/role/index'),
            meta: {title: '角色列表', icon: 'ums-role'}
          },
          {
            path: 'admin',
            name: 'admin',
            component: () => import('@/views/systemManage/ums/admin/index'),
            meta: {title: '用户列表', icon: 'ums-admin'}
          },
          {
            path: 'buttonManage',
            name: 'buttonManage',
            component: () => import('@/views/systemManage/ums/buttonManage/index'),
            meta: {title: '按钮权限管理', icon: 'ums-admin'}
          },
          {
            path: 'allocMenu',
            name: 'allocMenu',
            component: () => import('@/views/systemManage/ums/role/allocMenu'),
            meta: {title: '分配菜单'},
            hidden: true
          },
          {
            path: 'allocResource',
            name: 'allocResource',
            component: () => import('@/views/systemManage/ums/role/allocResource'),
            meta: {title: '分配资源'},
            hidden: true
          },
          {
            path: 'menu',
            name: 'menu',
            component: () => import('@/views/systemManage/ums/menu/index'),
            meta: {title: '菜单列表', icon: 'ums-menu'}
          },
          {
            path: 'addMenu',
            name: 'addMenu',
            component: () => import('@/views/systemManage/ums/menu/add'),
            meta: {title: '添加菜单'},
            hidden: true
          },
          {
            path: 'updateMenu',
            name: 'updateMenu',
            component: () => import('@/views/systemManage/ums/menu/update'),
            meta: {title: '修改菜单'},
            hidden: true
          },
          {
            path: 'resource',
            name: 'resource',
            component: () => import('@/views/systemManage/ums/resource/index'),
            meta: {title: '资源列表', icon: 'ums-resource'}
          },
          {
            path: 'resourceCategory',
            name: 'resourceCategory',
            component: () => import('@/views/systemManage/ums/resource/categoryList'),
            meta: {title: '资源分类'},
            hidden: true
          }

        ]
      },

    ]
  },
  {
    path: '/schoolManage',
    component: LayoutHide,
    redirect: 'noredirect',
    name: 'schoolManage',
    meta: {title: '校园信息管理', icon: 'school'},
    children: [
      {
        path: '/schoolManage/school',
        component: Layout,
        redirect: 'noredirect',
        name: 'school',
        meta: {title: '学校管理', icon: 'schoolChild'},
        children: [
          {
            path: 'schoolList',
            name: 'schoolList',
            component: () => import('@/views/schoolManage/school/schoolList/index'),
            meta: {title: '学校列表', icon: 'tags'}
          },
          {
            path: 'importFile',
            name: 'importFile',
            component: () => import('@/views/schoolManage/school/schoolList/importSchool'),
            meta: {title: '导入学校', icon: 'tags'},
            hidden: true
          },
          {
            path: 'studentGrade',
            name: 'studentGrade',
            component: () => import('@/views/schoolManage/school/studentGrade/index'),
            meta: {title: '年级列表', icon: 'tags'}
          },
          {
            path: 'studentClass',
            name: 'studentClass',
            component: () => import('@/views/schoolManage/school/studentClass/index'),
            meta: {title: '班级列表', icon: 'tags'}
          },
          {
            path: 'teacher',
            name: 'teacher',
            component: () => import('@/views/schoolManage/school/teacher/index'),
            meta: {title: '教职工', icon: 'tags'}
          },
          {
            path: 'importTeacher',
            name: 'importTeacher',
            component: () => import('@/views/schoolManage/school/teacher/import'),
            meta: {title: '导入教师', icon: 'tags'},
            hidden: true
          },
          {
            path: 'importGrade',
            name: 'importGrade',
            component: () => import('@/views/schoolManage/school/studentGrade/import'),
            meta: {title: '导入年级', icon: 'tags'},
            hidden: true
          },
          {
            path: 'importClass',
            name: 'importClass',
            component: () => import('@/views/schoolManage/school/studentClass/import'),
            meta: {title: '导入班级', icon: 'tags'},
            hidden: true
          },
          {
            path: 'importStudent',
            name: 'importStudent',
            component: () => import('@/views/schoolManage/school/student/import'),
            meta: {title: '导入学生', icon: 'tags'},
            hidden: true
          },
          // {
          //   path: 'importChargeGrade',
          //   name: 'importChargeGrade',
          //   component: () => import('@/views/schoolManage/school/chargeGrade/import'),
          //   meta: {title: '批量修改班级导入', icon: 'tags'},
          //   hidden: true
          // },
          {
            path: 'student',
            name: 'student',
            component: () => import('@/views/schoolManage/school/student/index'),
            meta: {title: '学生', icon: 'tags'}
          },
        ]
      },
    ]
  },
  {
    path: '/faceManage',
    component: LayoutHide,
    redirect: 'noredirect',
    name: 'faceManage',
    meta: {title: '刷脸消费管理', icon: 'face'},
    children: [
      {
        path: '/faceManage/statistics',
        component: Layout,
        redirect: 'noredirect',
        name: 'statistics',
        meta: {title: '数据统计', icon: 'data'},
        children: [
          {
            path: 'deviceDay',
            name: 'deviceDay',
            component: () => import('@/views/faceManage/statistics/deviceDay/index'),
            meta: {title: '机具日报表', icon: 'tags'}
          },
          {
            path: 'deviceMonth',
            name: 'deviceMonth',
            component: () => import('@/views/faceManage/statistics/deviceMonth/index'),
            meta: {title: '机具月报表', icon: 'tags'}
          },
          {
            path: 'consumeOrderReport',
            name: 'consumeOrderReport',
            component: () => import('@/views/faceManage/statistics/consumeOrderReport/index'),
            meta: {title: '学校消费报表', icon: 'tags'}
          },
          {
            path: 'faceReportNow',
            name: 'faceReportNow',
            component: () => import('@/views/faceManage/statistics/faceReportNow/index'),
            meta: {title: '人脸采集报表', icon: 'tags'}
          },
          {
            path: 'shopConsume',
            name: 'shopConsume',
            component: () => import('@/views/faceManage/statistics/shopConsume/index'),
            meta: {title: '商户消费报表', icon: 'tags'}
          },
          {
            path: 'studentConsume',
            name: 'studentConsume',
            component: () => import('@/views/faceManage/statistics/studentConsume/index'),
            meta: {title: '学生消费报表', icon: 'tags'}
          },
          {
            path: 'teacherConsume',
            name: 'teacherConsume',
            component: () => import('@/views/faceManage/statistics/teacherConsume/index'),
            meta: {title: '教师消费报表', icon: 'tags'}
          },
          {
            path: 'noConsume',
            name: 'noConsume',
            component: () => import('@/views/faceManage/statistics/noConsume/index'),
            meta: {title: '未消费人员报表', icon: 'tags'}
          },

        ]
      },
      {
        path: '/faceManage/rechargeManege',
        component: Layout,
        redirect: 'rechargeManege',
        name: 'rechargeManege',
        meta: {title: '银行充值余额管理', icon: 'data'},
        children: [
          {
            path: 'recharge',
            name: 'recharge',
            component: () => import('@/views/faceManage/rechargeManege/recharge/index'),
            meta: {title: '充值余额管理', icon: 'tags'},
            hidden: true
          },
          {
            path: 'rechargeLog',
            name: 'rechargeLog',
            component: () => import('@/views/faceManage/rechargeManege/rechargeLog/index'),
            meta: {title: '充值订单查询', icon: 'tags'},
            hidden: true
          },
          {
            path: 'refund',
            name: 'refund',
            component: () => import('@/views/faceManage/rechargeManege/refund/index'),
            meta: {title: '充值退款订单查询', icon: 'tags'},
            hidden: true
          },
          {
            path: 'rechargeReport',
            name: 'rechargeReport',
            component: () => import('@/views/faceManage/rechargeManege/rechargeReport/index'),
            meta: {title: '充值报表查询', icon: 'tags'},
            hidden: true
          },
        ]
      },
      {
        path: '/faceManage/trading',
        component: Layout,
        redirect: 'noredirect',
        name: 'trading',
        meta: {title: '交易管理', icon: 'ums'},
        children: [
          {
            path: 'aliBill',
            name: 'aliBill',
            component: () => import('@/views/faceManage/trading/aliBill/index'),
            meta: {title: '支付宝现金账单查询', icon: 'tags'}
          },
          {
            path: 'consumeOrder1',
            name: 'consumeOrder1',
            component: () => import('@/views/faceManage/trading/consumeOrder/index'),
            meta: {title: '现金订单查询', icon: 'tags'}
          },
          {
            path: 'consumeDebtOrder',
            name: 'consumeDebtOrder',
            component: () => import('@/views/faceManage/trading/consumeDebtOrder/index'),
            meta: {title: '欠款订单查询', icon: 'tags'}
          },
          {
            path: 'reconciliation',
            name: 'reconciliation',
            component: () => import('@/views/faceManage/trading/reconciliation/index'),
            meta: {title: '支付宝现金账单明细', icon: 'tags'}
          },
          {
            path: 'timesBill',
            name: 'timesBill',
            component: () => import('@/views/faceManage/trading/timesBill/index'),
            meta: {title: '次数账单查询', icon: 'tags'}
          },
          {
            path: 'timesOrder',
            name: 'timesOrder',
            component: () => import('@/views/faceManage/trading/timesOrder/index'),
            meta: {title: '次数订单查询', icon: 'tags'}
          },
        ]
      },
      {
        path: '/faceManage/shop',
        component: Layout,
        redirect: 'noredirect',
        name: 'shop',
        meta: {title: '店铺管理', icon: 'shop'},
        children: [
          {
            path: 'schShop',
            name: 'schShop',
            component: () => import('@/views/faceManage/shop/list/index'),
            meta: {title: '店铺列表', icon: 'tags'}
          },
          {
            path: 'importSchShop',
            name: 'importSchShop',
            component: () => import('@/views/faceManage/shop/list/import'),
            meta: {title: '导入', icon: 'tags'},
            hidden: true
          },
        ]
      },
      {
        path: '/faceManage/device',
        component: Layout,
        redirect: 'noredirect',
        name: 'device',
        meta: {title: '机具管理', icon: 'device'},
        children: [
          {
            path: 'aliSupplier',
            name: 'aliSupplier',
            component: () => import('@/views/faceManage/device/aliSupplier/index'),
            meta: {title: '设备供应商', icon: 'tags'}
          },
          {
            path: 'aliItem',
            name: 'aliItem',
            component: () => import('@/views/faceManage/device/aliItem/index'),
            meta: {title: '设备物料', icon: 'tags'}
          },
          {
            path: 'monitor',
            name: 'monitor',
            component: () => import('@/views/faceManage/device/monitor/index'),
            meta: {title: '机具监测', icon: 'tags'}
          },
        ]
      },
      {
        path: '/faceManage/withHold',
        component: Layout,
        redirect: 'noredirect',
        name: 'withHold',
        meta: {title: '代扣白名单管理', icon: 'withHold'},
        children: [
          {
            path: 'teacherHold',
            name: 'teacherHold',
            component: () => import('@/views/faceManage/withHold/teacher/index'),
            meta: {title: '教师白名单', icon: 'tags'}
          },
          {
            path: 'studentHold',
            name: 'studentHold',
            component: () => import('@/views/faceManage/withHold/student/index'),
            meta: {title: '学生白名单', icon: 'tags'}
          },
          {
            path: 'importTeacher',
            name: 'importTeacher',
            component: () => import('@/views/faceManage/withHold/teacher/import'),
            meta: {title: '导入教师', icon: 'tags'},
            hidden: true
          },
          {
            path: 'importStudent',
            name: 'importStudent',
            component: () => import('@/views/faceManage/withHold/student/import'),
            meta: {title: '导入学生', icon: 'tags'},
            hidden: true
          },
        ]
      },
      {
        path: '/faceManage/serverConfig',
        component: Layout,
        redirect: 'noredirect',
        name: 'serverConfig',
        meta: {title: '服务配置', icon: 'server-config'},
        children: [
          {
            path: 'consumeConfig',
            name: 'consumeConfig',
            component: () => import('@/views/faceManage/serverConfig/consumeConfig/index'),
            meta: {title: '消费限额配置', icon: 'tags'}
          },
          {
            path: 'subsidiesConfig',
            name: 'subsidiesConfig',
            component: () => import('@/views/faceManage/serverConfig/subsidiesConfig/index'),
            meta: {title: '充值/补贴配置', icon: 'tags'}
          },
          {
            path: 'countConfig',
            name: 'countConfig',
            component: () => import('@/views/faceManage/serverConfig/countConfig/index'),
            meta: {title: '充值/次数配置', icon: 'tags'},
            hidden: true
          },
          {
            path: 'importCharge',
            name: 'importCharge',
            component: () => import('@/views/faceManage/serverConfig/subsidiesConfig/import'),
            meta: {title: '导入', icon: 'tags'},
            hidden: true
          },
          {
            path: 'importCountCharge',
            name: 'importCountCharge',
            component: () => import('@/views/faceManage/serverConfig/countConfig/import'),
            meta: {title: '导入', icon: 'tags'},
            hidden: true
          },
        ]
      },
    ]
  },
  {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js